module.exports = __webpack_public_path__ + "static/media/service_system_11.f40cc38e.png";